(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-category', {
            parent: 'entity',
            url: '/rpt-category',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'RptCategories'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-category/rpt-categories.html',
                    controller: 'RptCategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-category-detail', {
            parent: 'entity',
            url: '/rpt-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'RptCategory'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-category/rpt-category-detail.html',
                    controller: 'RptCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptCategory', function($stateParams, RptCategory) {
                    return RptCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-category-detail.edit', {
            parent: 'rpt-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-category.new', {
            parent: 'rpt-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', 'ROLES', function (CoreService, ROLES) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN) ? null : CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('rpt-category');
                });
            }]
        })
        .state('rpt-category.edit', {
            parent: 'rpt-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-category.delete', {
            parent: 'rpt-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-delete-dialog.html',
                    controller: 'RptCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
